import { warn, } from '../../jsCore/application/console';
import {TYPES} from '../../jsCore/organizedByType/actions/actionCounterProviderActions';
import { fetchPostMetadata, } from
  '../../jsCore/providers/actionCounter/currentPostActionCounterProvider';


const { DATA_RECEIVED, } = TYPES;


function getPostData(){
  return (dispatch, getState) => fetchPostMetadata()
    .then((state) => dispatch({
      type: DATA_RECEIVED,
      state,
    }))
    .catch(warn);
}


export const communityDisclaimerActions = {
  fetchData: getPostData,
};



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/communityDisclaimerActions.js